import React, { useContext } from 'react';
import DialogModal from '@/modules/common/components/Modal/DialogModal';
import { Button, Typography } from '@pw-tech/omni-ui';
import Image from 'next/image';
import { RegistrationContext } from '../../contexts/RegistrationContextProvider';
type Props = {
  isOpen: boolean;
  onClose: () => void;
};
const EligibleForAdmissionModal = ({
  isOpen,
  onClose
}: Props) => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  return <DialogModal isOpen={isOpen} title="" onClose={onClose} onSubmit={() => null} showHeader={false} showSeparator={false} showFooter={false} showCancelButton={false} showSubmitButton={false} closeOnOutsideClick={false} showCloseIcon size="extra-small" data-sentry-element="DialogModal" data-sentry-component="EligibleForAdmissionModal" data-sentry-source-file="EligibleForAdmissionModal.tsx">
      <div className="relative flex flex-col items-center gap-4">
        <div className="relative flex flex-col items-center gap-1 text-center">
          <Typography variant="heading3" weight="semi-bold" className="!text-[#099250]" data-sentry-element="Typography" data-sentry-source-file="EligibleForAdmissionModal.tsx">
            Congratulations
          </Typography>
          <Typography variant="heading4" weight="semi-bold" className="!text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="EligibleForAdmissionModal.tsx">
            You are eligible for {registrationDetails?.isEligibleForDirectAdmission ? 'direct' : ''}{' '}
            admission.
          </Typography>
          <Typography variant="regular" className="!text-[#3D3D3D] !text-sm" data-sentry-element="Typography" data-sentry-source-file="EligibleForAdmissionModal.tsx">
            Hurry up! Seats are filling fast.
          </Typography>
        </div>
        <Button variant="primary" onClick={onClose} className="w-1/2" data-sentry-element="Button" data-sentry-source-file="EligibleForAdmissionModal.tsx">
          Continue
        </Button>
        <Image src="/images/registerPage/coupon-code-success.gif" alt="success-gif" className="absolute left-0 rounded-full" width={200} height={200} data-sentry-element="Image" data-sentry-source-file="EligibleForAdmissionModal.tsx" />
        <Image src="/images/registerPage/coupon-code-success.gif" alt="success-gif" className="absolute right-0 rounded-full" width={200} height={200} data-sentry-element="Image" data-sentry-source-file="EligibleForAdmissionModal.tsx" />
      </div>
    </DialogModal>;
};
export default EligibleForAdmissionModal;